// extracted by mini-css-extract-plugin
export default {"spinnerOverLay":"spinner_spinnerOverLay__G9+QJ","loadingSpinner":"spinner_loadingSpinner__JUNnY","spin":"spinner_spin__TDSPj"};